export const slides = [
    {
        src:"Dibujos/libertad(1).jpg",
        framedSrc:"Dibujos/liberte_framed1.png",
        title: "Liberté",
        description: "crayon sur papier, 35.6 x 43.2cm, 2022",
        price: "480€",
        framed: true
    },
    {
        src:"Dibujos/Consciencia(1).jpg",
        framedSrc:"Dibujos/Conscience_framed.jpeg",
        title: "Conscience",
        description: "crayon sur papier, 43.2 x 35.6cm, 2022",
        price: "450€",
        framed: true
    },
    {
        src:"Dibujos/angustia.jpg",
        title: "Angoisse",
        description: "35.6 x 43.2 cm, 2021"
    },
    {
        src:"Dibujos/Incomprendida.jpg",
        title: "L'incomprise",
        description: "35.6 x 43.2 cm, 2024"
    },
    {
        src:"Dibujos/Ariadne.jpeg",
        framedSrc:"Dibujos/Ariadne-framed1.jpeg",
        title: "Ariadne",
        description: "pastel et crayon sur papier, 35.6 x 43.2cm, 2025",
        price: "450€",
        framed: true
    },
    {
        src:"Dibujos/Calliope.jpeg",
        framedSrc:"Dibujos/calliope-framed.jpeg",
        title: "Calliope",
        description: "crayon sur papier, 35.6 x 43.2cm, 2022",
        price: "500€",
        framed: true
    },
    {
        src:"Dibujos/Foi.jpg",
        framedSrc:"Dibujos/Foi_framed.jpeg",
        title: "Foi",
        description: "crayon sur papier, 35.6 x 43.2cm, 2022",
        price: "450€",
        framed: true
    },
    {
        src:"Dibujos/asenso.jpg",
        title: "Recommencer",
        description: "35.6 x 43.2 cm, 2021"
    },
    {
        src:"Dibujos/SombraPadre.jpg",
        title: "L'ombre du père",
        description: "35.6 x 43.2 cm, 2022",
        price: "380€"
    },
    {
        src:"Dibujos/Open.png",
        title: "Héritage",
        description:"70 x 90 cm, 2024"
    },
    {
        src:"Dibujos/Source.jpg",
        framedSrc:"Dibujos/GordianKnot-framed.jpeg",
        title: "Nœud Gordien",
        description:"fusain et crayon sur papier, 35.6 x 43.2 cm, 2023",
        price: "450€",
        framed: true
    },
    {
        src:"Dibujos/Voluntad-.jpg",
        framedSrc:"Dibujos/slipknot_framed.png",
        title: "Volonté",
        description:"fusain et crayon sur papier, 43.2 x 35.6 cm, 2023",
        price: "450€",
        framed: true
    },
    {
        src:"Dibujos/pacto.jpg",
        title: "Pacte",
        description:"43.2 x 35.6 cm, 2023"
    },
    {
        src:"Dibujos/contacto.jpg",
        title: "Contact",
        description:"35.6 x 43.2 cm, 2024"
    },
    {
        src:"Dibujos/Sabotaje.jpg",
        title: "Sabotage",
        description:"45 x 77.5 cm, 2024"
    },
    {
        src:"Dibujos/Nevermind.jpg",
        framedSrc:"Dibujos/Nevermind-framed.jpeg",
        title: "Laisse tomber",
        description:"fusain sur papier, 65 x 65 cm, 2024",
        price: "550€",
        framed: true
    },
    {
        src:"Dibujos/honestidad.jpg",
        framedSrc:"Dibujos/honesty-framed.jpeg",
        title: "Honnêteté",
        description:"fusain sur papier, 55 x 77 cm, 2024",
        price: "580€",
        framed: true
    },
    {
        src:"Dibujos/PourSoi-ll.jpg",
        title: "Pour soi II",
        description:"45 x 35 cm, 2026",
        price: "380€"
    },
    {
        src:"Dibujos/toujours.jpg",
        framedSrc:"Dibujos/toujours-framed.jpg",
        title: "Toujours",
        description:"fusain sur papier, 86 x 100 cm, 2024",
        price: "1400€ (VENDU)",
        framed: true
    },
    {
        src:"Dibujos/madameX.jpg",
        framedSrc:"Dibujos/MadameX_framed.jpg",
        title: "Les mains de Madame X",
        description:"crayon et feuille d'or sur papier, 55 x 42 cm, 2025",
        price: "500",
        framed: true
    },
    



];

